/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, NgZone, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {AppEventBusService} from '../events/app-event-bus.service';

@Component({
  standalone: false,
  selector: 'adn-object-states',
  template: `
    <div class="btn-group">
      <button *ngIf="!hideActivateValue" type="button" [disabled]="isActivateDisabled()" class="btn btn-default btn-xs" (click)="bulkAction('ACTIVE')">
        <span class="fa fa-power-off"></span>Activate
      </button>
      <button type="button" [disabled]="isArchiveDisabled()" class="btn btn-default btn-xs" (click)="bulkAction('INACTIVE')">
        <span class="fa fa-briefcase"></span>Archive
      </button>
      <button *ngIf="!hideHidden" type="button" [disabled]="isDeleteDisabled()" class="btn btn-default btn-xs" (click)="bulkAction('HIDDEN')">
        <span class="fa fa-trash"></span>Delete
      </button>
    </div>
  `
})
export class ObjectStatesComponent implements OnInit {
  @Input() list: any;
  @Input() hideActivate: boolean | string;

  hideActivateValue = false;
  hideHidden = false;

  constructor(
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly eventBus: AppEventBusService,
    private readonly ngZone: NgZone
  ) {
  }

  ngOnInit(): void {
    this.hideActivateValue = this.coerceBoolean(this.hideActivate);
    this.hideHidden = this.LocalNetworkProfile.isPureMarketplacePlatform();
  }

  isActivateDisabled(): boolean {
    return this.currentInclude() === 'ACTIVE';
  }

  isArchiveDisabled(): boolean {
    return this.currentInclude() === 'INACTIVE';
  }

  isDeleteDisabled(): boolean {
    return this.currentInclude() === 'HIDDEN';
  }

  bulkAction(action: string): void {
    if (!this.list || typeof this.list !== 'object' || !_.isFunction(this.list.doBulkAction)) {
      return;
    }
    this.ngZone.run(() => {
      this.list.doBulkAction(action);
      this.eventBus.runAsync();
    });
  }

  private currentInclude(): string {
    if (!this.list || typeof this.list !== 'object') {
      return 'ACTIVE';
    }
    return this.list.include || this.list.showingInclude || 'ACTIVE';
  }

  private coerceBoolean(value: any): boolean {
    return value === '' || value === true || value === 'true';
  }
}
